var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          [
            _c("date-range-picker", {
              ref: "picker",
              attrs: {
                startDate: _vm.startDate,
                opens: "right",
                ranges: _vm.ranges,
                "locale-data": _vm.date_locale,
              },
              on: { update: _vm.selectDate },
              model: {
                value: _vm.dateRange,
                callback: function ($$v) {
                  _vm.dateRange = $$v
                },
                expression: "dateRange",
              },
            }),
            _vm._v(" "),
            _c("LoadingButton", {
              attrs: {
                title: "Показать",
                className: "btn btn-outline-info",
                loading: _vm.loading,
                color: _vm.loadingColor,
                onClick: () => _vm.showRating(),
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body rating_table" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: { loading: _vm.loading, color: _vm.loadingColor },
          }),
          _vm._v(" "),
          !_vm.loading && _vm.records
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Количество записей на странице"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "form-control",
                      staticStyle: { "max-width": "200px" },
                      attrs: { type: "number", placeholder: "Количество" },
                      on: { change: _vm.updatePerPage },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "data-table",
                    _vm._b(
                      { ref: "tableData" },
                      "data-table",
                      _vm.tableData,
                      false
                    )
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }